import { Table as BaseTable } from './Table'
import { Head } from './Head'
import { Body } from './Body'
import { Row } from './Row'
import { Cell } from './Cell'

export const Table = Object.assign(BaseTable, { Head, Body, Row, Cell })
